<template>
  <div>
    <div v-bind:id="nombreDelDivPrincipal" class="d-none justify-content-center align-items-center">
       <div id="secciongeneral" class="d-flex flex-wrap justify-content-center align-items-center">
        <div class="d-flex flex-wrap align-items-center justify-content-center">
          <figure class="text-center mb-5 mx-5">
            <img src="../../assets/logo-pj-transparente-blanco.png" alt="Logo de Poder Judicial del Estado de Aguascalientes" />
          </figure>
          <h3 class="w-100">PROCESANDO INFORMACIÓN</h3>
          <h4 class="w-100">ESPERE UN MOMENTO</h4>
          <div class="w-100 mb-5 justify-content-center text-center position-relative d-flex">
            <i class="fas fa-spinner fa-spin fa-5x" style="left: 0; right: 0"></i>
          </div>
        </div>
      </div>   
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        nombreDelDivPrincipal: this.props
      }
    },
    props: ['props'],
  }
</script>


<style scoped>
  #cargandoInformacion_div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 50 !important;
  }

  #cargandoInformacionPaginaWeb_div {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 50 !important;
  }

    #cargandoInformacion_div > #secciongeneral > div, #cargandoInformacionPaginaWeb_div > #secciongeneral > div {
      background: rgba(34,34,34,1);
      width: 460px;
      height: 600px;
      align-content: center;
      margin-top: -5vh;
    }

    #cargandoInformacion_div img, #cargandoInformacionPaginaWeb_div img {
      margin-top: -5vh;
      width: 70%;
    }

    #cargandoInformacion_div > #secciongeneral {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0,.5);
    }

    #cargandoInformacionPaginaWeb_div > #secciongeneral {
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0,.5);
    }

  h3 {
    color: #FFFFFF;
    text-align: center;
    margin-top: 3vh;
  }

  h4 {
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 2vh;
  }

  i {
    position: absolute;
    top: 10px;
    left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Comunes/CargandoInformacion.vue